module.exports = __webpack_public_path__ + "static/media/icon_time.c53c3449.svg";